// @ts-ignore  
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore  
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import "./LoadingSpinner.scss";

const LoadingSpinner = () => {
    return (
        <div data-testid="hrb-loading-spinner" className="hrb-loading-spinner">
            <FontAwesomeIcon icon={faSpinner} size="3x" pulse />
        </div>
    );
};

export default LoadingSpinner;
